import { render, staticRenderFns } from "./HeaderNotificationList.vue?vue&type=template&id=37cb619f&scoped=true&"
import script from "./HeaderNotificationList.vue?vue&type=script&lang=js&"
export * from "./HeaderNotificationList.vue?vue&type=script&lang=js&"
import style0 from "./HeaderNotificationList.vue?vue&type=style&index=0&id=37cb619f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cb619f",
  null
  
)

export default component.exports